import React, { Component } from 'react'
import PropTypes from 'prop-types';
import client from '../Contentful_API/api';
import { withStyles } from '@material-ui/core/styles';
import styles from './Styles';
import Grid from '@material-ui/core/Grid';
import { SimpleShareButtons } from "react-simple-share";




const Loader = () => (
	<div class="divLoader">
		<svg class="svgLoader" viewBox="0 0 100 100" width="10em" height="10em">
			<path stroke="none" d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" fill="#51CACC" transform="rotate(179.719 50 51)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 51;360 50 51" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></path>
		</svg>
	</div>
);

class SingleKnowledge extends Component {
	constructor() {
		super()
		this.state = { knowlegeCenter: null, loading: true }
	}

	componentDidMount() {
		client.getEntries({ content_type: 'knowlegeCenter', 'fields.slug': this.props.match.params.slug })
			.then(response => {
				if (response.items && response.items.length > 0) {
					return response.items[0].fields;
				}
				throw new Error("No entry found");
			})
			.then(fields => {
				this.setState({
					knowlegeCenter: fields,
					loading: false
				});
			})
			.catch(error => {
				console.error(error);
				this.setState({ loading: false });
			});
	}

	render(props) {
		const { classes } = this.props;

		let title;
		let slug;
		let imageurl;
		let description;

		if (this.state.knowlegeCenter) {
			title = this.state.knowlegeCenter.title;
			imageurl = this.state.knowlegeCenter.knowledgeimage ? this.state.knowlegeCenter.knowledgeimage.fields.file.url : "";
			slug = this.state.knowlegeCenter.slug;
			description = this.state.knowlegeCenter.description;
		}

		return (
			<div className={classes.layout}>
				{this.state.loading ? <Loader /> : null}
				{this.state.knowlegeCenter ? (
					<Grid container>
						<Grid item md={6}>
							<div className={classes.imageLayout}>
								<img className={classes.img} alt="complex" src={imageurl} />
							</div>
						</Grid>
						<Grid item md={6}>
							<br />
							<div className={classes.eventBody}>
								<h2>{title}</h2>
								<div dangerouslySetInnerHTML={{ __html: description }} />
							</div>
							<div className={classes.socialShare}>
								<h5>Share with</h5>
								<SimpleShareButtons
									url={"https://www.mof.gov.tl/knowledgedetails/" + slug}
									size="35px"
								/>
							</div>
						</Grid>
					</Grid>
				) : (
					!this.state.loading && <div>No Knowledge details found</div>
				)}
				<br />
			</div>
		);
	}
}

SingleKnowledge.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SingleKnowledge);




